<script lang="ts">
  import PageSection from '@athena-lib/Page/PageSection.svelte';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { HeadingSmall } from '@athena-lib/Text';
  import { Column, Columns } from '@athena-lib/Columns';
  import { Button } from '@athena-lib/Button';
  import { Stack, StackItem } from '@athena-lib/Stack';
  import { TextField } from '@athena-lib/Fields';
  import { Type } from '@sinclair/typebox';
  import AccountTabs from './AccountTabs.svelte';
  import CountryStateSelector from './CountryStateSelector.svelte';
  import type { EditAccountData } from '$lib/server/external/types';
  import { goto } from '$app/navigation';
  import { post } from '$lib/http';

  const translations = getCommonTranslations();

  const { data }: { data: EditAccountData } = $props();
  let formData: EditAccountData['accountData']['shipping'] = $state(data.accountData.shipping);

  function save() {
    post(
      '/account/set_user_data',
      { group: 'shipping', address: formData },
      Type.Object({ user: Type.String() }),
    );
    goto('/customer');
  }
</script>

<AccountTabs currentPage="customer" accountData={data.accountData} market={data.market}
></AccountTabs>
<PageSection backgroundColor="medium">
  <Stack>
    <StackItem>
      <Columns collapseBelow="md">
        <Column>
          <HeadingSmall>{translations['shippingAddress']}</HeadingSmall>
        </Column>
        <Column class="hidden flex-row justify-end gap-4 md:flex">
          <Button element="a" link={{ href: '/customer' }} color="white" size="small"
            >{translations.cancel}</Button
          >
          <Button onClick={save} size="small">{translations.save}</Button>
        </Column>
      </Columns>
    </StackItem>
    <StackItem>
      <hr class="mb-4 mt-3" />
    </StackItem>
    <StackItem>
      <Columns collapseBelow="md">
        <Column>
          <TextField bind:value={formData.name} type="text" label={translations.nameOrCompany} />
        </Column>
        <Column>
          <TextField bind:value={formData.att_name} type="text" label={translations.attName} />
        </Column>
      </Columns>
    </StackItem>
    <StackItem>
      <Columns collapseBelow="md">
        <Column>
          <TextField bind:value={formData.address} type="text" label={translations.address1} />
        </Column>
        <Column>
          <TextField bind:value={formData.address2} type="text" label={translations.address2} />
        </Column>
      </Columns>
    </StackItem>
    <StackItem>
      <Columns collapseBelow="md">
        <Column>
          <Columns collapseBelow="md">
            <Column>
              <TextField bind:value={formData.zip} type="text" label={translations.zipCode} />
            </Column>
            <Column>
              <TextField bind:value={formData.city} type="text" label={translations.city} />
            </Column>
          </Columns>
        </Column>
        <Column>
          <CountryStateSelector
            countries={data.countries}
            bind:county={formData.county}
            bind:country_code={formData.country_code}
          />
        </Column>
      </Columns>
    </StackItem>
    <StackItem>
      <Columns collapseBelow="md">
        <Column width="1/2">
          <TextField bind:value={formData.phone} type="text" label={translations.phone} />
        </Column>
      </Columns>
    </StackItem>
    <StackItem class="hidden justify-center gap-3  max-md:flex">
      <Button wide element="a" link={{ href: '/customer' }} color="white" size="small"
        >{translations.cancel}</Button
      >
      <Button wide onClick={save} size="small">{translations.save}</Button>
    </StackItem>
  </Stack>
</PageSection>
